export default class Scene {
    constructor($el) {
        this.$el = $el;
        this.carousel = this.$el.querySelector('[data-carousel]');
        this.products = [...this.$el.querySelectorAll('[data-carousel-item]')];

        if (!this.carousel || !this.products.length) {
            return;
        }

        this.onResize = this.updateCarousel.bind(this);
        this.updateCarousel();
        window.addEventListener('resize', this.onResize);
    }

    updateCarousel() {
        const productCount = this.products.length;
        const sceneWidth = this.$el.clientWidth || 0;
        const itemWidth = this.products[0]?.offsetWidth || 180;
        const maxRadius = Math.max((sceneWidth / 2) - itemWidth, itemWidth);
        const minRadius = Math.max(itemWidth * 0.8, 90);
        const idealRadius = Math.max((productCount * itemWidth) / (2 * Math.PI), sceneWidth * 0.20, minRadius);
        const radius = Math.min(idealRadius, maxRadius);
        const angleStep = 360 / productCount;

        this.carousel.style.setProperty('--carousel-radius', `${radius}px`);
        this.carousel.style.setProperty('--carousel-item-count', productCount);

        this.products.forEach((product, index) => {
            const angle = angleStep * index;
            product.style.setProperty('--carousel-item-angle', `${angle}deg`);
        });
    }
}
